module.exports = __webpack_public_path__ + "img/sr-free-review-checkedr.2269fc01.png";